import React, { createContext, useState, useEffect, useContext } from 'react';
import { GeolocationService } from '../Services/GeolocationService';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currentCountry, setCurrentCountry] = useState('');

  useEffect(() => {
    initializeCurrency();
  }, []);

  const initializeCurrency = async () => {
    try {
      const geoData = await GeolocationService.getIPAndGeolocation();
      setCurrentCountry(geoData.countryName);
    } catch (error) {
      console.error('Error initializing currency:', error);
      setCurrentCountry('');
    }
  };

  const isSriLanka = () => {
    return currentCountry.toLowerCase() === 'sri lanka';
  };

  const getCurrencySymbol = () => {
    return isSriLanka() ? 'Rs' : '$';
  };

  // Get the current applicable price
  const getPrice = (item) => {
    if (isSriLanka()) {
      // For Sri Lankan users
      return item.OfferPrice && parseFloat(item.OfferPrice) > 0
        ? parseFloat(item.OfferPrice)
        : parseFloat(item.Price);
    } else {
      // For International users
      return item.InternationalOfferPrice && parseFloat(item.InternationalOfferPrice) > 0
        ? parseFloat(item.InternationalOfferPrice)
        : parseFloat(item.InternationalPrice || item.Price);
    }
  };

  // Get the original price (for strikethrough display)
  const getOriginalPrice = (item) => {
    if (isSriLanka()) {
      return parseFloat(item.Price);
    } else {
      return parseFloat(item.InternationalPrice || item.Price);
    }
  };

  // Check if item is on sale
  const isOnSale = (item) => {
    if (isSriLanka()) {
      return item.OfferPrice && parseFloat(item.OfferPrice) > 0 && parseFloat(item.OfferPrice) < parseFloat(item.Price);
    } else {
      return item.InternationalOfferPrice && 
             parseFloat(item.InternationalOfferPrice) > 0 && 
             parseFloat(item.InternationalOfferPrice) < parseFloat(item.InternationalPrice || item.Price);
    }
  };

  // Format price with currency symbol
  const formatPrice = (price) => {
    const symbol = getCurrencySymbol();
    return `${symbol} ${parseFloat(price).toFixed(2)}`;
  };

  // Format complete price display including sale price if applicable
  const formatPriceDisplay = (item) => {
    const currentPrice = getPrice(item);
    const originalPrice = getOriginalPrice(item);
    const onSale = isOnSale(item);

    if (onSale) {
      return {
        currentPrice: formatPrice(currentPrice),
        originalPrice: formatPrice(originalPrice),
        isOnSale: true
      };
    } else {
      return {
        currentPrice: formatPrice(currentPrice),
        originalPrice: null,
        isOnSale: false
      };
    }
  };

  return (
    <CurrencyContext.Provider value={{
      currentCountry,
      isSriLanka,
      getCurrencySymbol,
      getPrice,
      getOriginalPrice,
      isOnSale,
      formatPrice,
      formatPriceDisplay
    }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);